'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ComponentSink = exports.ComponentSinkRenderer = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _class, _class2, _desc, _value, _class3;

exports.makeSink = makeSink;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _mobx = require('mobx');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

/**
 * Creates a sink and a renderer for a given component.
 */
function makeSink(InnerComponent) {
  var sink = _mobx.observable.shallowBox();
  var Sink = function Sink(props) {
    return _react2.default.createElement(ComponentSink, (0, _extends3.default)({ sink: sink }, props));
  };
  var Renderer = function Renderer(rendererProps) {
    return _react2.default.createElement(
      ComponentSinkRenderer,
      (0, _extends3.default)({}, rendererProps, { sink: sink }),
      function (props) {
        return _react2.default.createElement(InnerComponent, props);
      }
    );
  };

  return {
    Sink: Sink,
    Renderer: Renderer
  };
}

/**
 * Renders a single sink.
 */

var ComponentSinkRenderer = exports.ComponentSinkRenderer = (0, _mobxReact.observer)(_class = function (_React$Component) {
  (0, _inherits3.default)(ComponentSinkRenderer, _React$Component);

  function ComponentSinkRenderer() {
    (0, _classCallCheck3.default)(this, ComponentSinkRenderer);
    return (0, _possibleConstructorReturn3.default)(this, (ComponentSinkRenderer.__proto__ || (0, _getPrototypeOf2.default)(ComponentSinkRenderer)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComponentSinkRenderer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          sink = _props.sink,
          props = (0, _objectWithoutProperties3.default)(_props, ['children', 'sink']);

      var sinkValue = sink.get();
      if (!sinkValue) {
        return null;
      }

      return children((0, _extends3.default)({}, props, sinkValue.props));
    }
  }]);
  return ComponentSinkRenderer;
}(_react2.default.Component)) || _class;

ComponentSinkRenderer.propTypes = {
  children: _propTypes2.default.func.isRequired,
  sink: _propTypes2.default.any.isRequired
};

/**
 * Stuffs data into a sink so it'll be rendered.
 */

var ComponentSink = exports.ComponentSink = (0, _mobxReact.observer)(_class2 = (_class3 = function (_React$Component2) {
  (0, _inherits3.default)(ComponentSink, _React$Component2);

  function ComponentSink() {
    (0, _classCallCheck3.default)(this, ComponentSink);
    return (0, _possibleConstructorReturn3.default)(this, (ComponentSink.__proto__ || (0, _getPrototypeOf2.default)(ComponentSink)).apply(this, arguments));
  }

  (0, _createClass3.default)(ComponentSink, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.updateSink(this.props);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeSink();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      this.updateSink(nextProps);
    }
  }, {
    key: 'updateSink',
    value: function updateSink(nextProps) {
      var sink = nextProps.sink,
          props = (0, _objectWithoutProperties3.default)(nextProps, ['sink']);

      sink.set({
        props: props
      });
    }
  }, {
    key: 'removeSink',
    value: function removeSink() {
      this.props.sink.set(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ComponentSink;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class3.prototype, 'updateSink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'updateSink'), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, 'removeSink', [_mobx.action], (0, _getOwnPropertyDescriptor2.default)(_class3.prototype, 'removeSink'), _class3.prototype)), _class3)) || _class2;

ComponentSink.propTypes = {
  sink: _propTypes2.default.any.isRequired
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@taxfyle/web-commons/lib/components/ComponentSink/index.js
// module id = 613
// module chunks = 0